// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedConnectionsAddOnSuccess_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M5.31589 13.008C5.62046 13.8704 6.11566 14.642 6.75055 15.2716 6.48965 15.708 6.01415 16 5.47082 16 4.64678 16 3.97877 15.3284 3.97877 14.5 3.97877 13.7242 4.56466 13.0859 5.31589 13.008ZM15.2211 6.81788C15.6851 6.56355 16 6.06874 16 5.5 16 4.67157 15.332 4 14.508 4 13.7261 4 13.0846 4.60466 13.0211 5.37424 13.8597 5.68765 14.6092 6.18515 15.2211 6.81788ZM12.4677 4.07036C11.3734 2.80209 9.75866 2 7.95755 2 7.05516 2 6.19955 2.20134 5.43274 2.56178 5.30889 1.8576 4.89186 1.25518 4.31296.886519 5.40489.319935 6.64406 0 7.95755 0 10.48 0 12.7283 1.17993 14.1863 3.02073 13.4757 3.11301 12.8591 3.50681 12.4677 4.07036ZM.881815 4.33596C.318238 5.43373 0 6.6795 0 8 0 10.5318 1.1699 12.789 2.99589 14.2549 3.066 13.5306 3.4435 12.8969 3.99556 12.4873 2.76483 11.3882 1.98939 9.78513 1.98939 8 1.98939 7.0928 2.18966 6.23262 2.54818 5.46172 1.84775 5.33721 1.24852 4.91796.881815 4.33596ZM4.47612 3C4.47612 3.82843 3.80811 4.5 2.98408 4.5 2.16005 4.5 1.49204 3.82843 1.49204 3 1.49204 2.17157 2.16005 1.5 2.98408 1.5 3.80811 1.5 4.47612 2.17157 4.47612 3Z" class="svg-bg"/>
  <circle cx="10.968" cy="11" r="5" fill="#29C192"/>
  <circle cx="10.968" cy="11" r="5" stroke="white"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M14.5187 9.4046L13.2879 8.16716L9.94694 11.5259L8.36439 9.93493L7.13352 11.1724L8.71606 12.7634L9.94694 14.0008L11.1778 12.7634L14.5187 9.4046Z" class="svg-fg"/>
</svg>
`;
/**
 * IconMedConnectionsAddOnSuccess is a generated icon component.
 */
let IconMedConnectionsAddOnSuccess = IconMedConnectionsAddOnSuccess_1 = class IconMedConnectionsAddOnSuccess extends IconBaseElement {
    render() {
        return html `${IconMedConnectionsAddOnSuccess_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedConnectionsAddOnSuccess.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s16IconSvg],
    ['s32', _s16IconSvg],
    ['s40', _s16IconSvg],
    ['s48', _s16IconSvg],
    ['s64', _s16IconSvg],
    ['s72', _s16IconSvg],
    ['s80', _s16IconSvg],
]);
IconMedConnectionsAddOnSuccess = IconMedConnectionsAddOnSuccess_1 = __decorate([
    customElement('zui-icon-med-connections-add-on-success')
], IconMedConnectionsAddOnSuccess);
export { IconMedConnectionsAddOnSuccess };
